import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=4d23f5ad&scoped=true"
var script = {}
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=4d23f5ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23f5ad",
  null
  
)

export default component.exports